import classnames from 'classnames';
import React, {useContext} from 'react';
import './_styles.scss';
import {PostContext} from 'shared/front/components/Post/context';
import PostDetailBlockBody from './components/PostDetailBlockBody';
import PostBlockLabel from '../PostBlockLabel';
import PostDetailBlockTitle from './components/PostDetailBlockTitle';
import PostDetailBlockUser from './components/PostDetailBlockUser';
import PostBlockSocials from '../PostBlockSocials';
import PostBlockCta from '../PostBlockCta';
import PostBlockThumbnail from '../PostBlockThumbnail';

export const F_STEP_BLOCK_CLOSE_DISABLED = 1;
export const F_STEP_HEIGHT_CUSTOM = 2;
export const F_STEP_DISCOVERY_STEP_REQUIRED = 4;
export const F_OPTION_POKE_CARD_WITH_POINTER = 131072;

export const FADE_OUT_DELAY = 500;
export const JIMO_LABEL_HEIGHT = 34;
export const NO_JIMO_LABEL_EXTRA_HEIGHT = 24;

export const PostDetail = ({}) => {
  const {theme, language} = useContext(PostContext);

  const {cards} = theme ?? {};
  const {backgroundColor, shadow, borderRadius} = cards ?? {};
  const {x, y, blur, color} = shadow ?? {};
  const boxShadow =
    shadow != null && color != null
      ? `${x ?? 0}px ${y ?? 0}px ${blur ?? 0}px ${color}`
      : undefined;

  const isRtl = ['AR', 'HE'].includes(language);

  return (
    <div
      dir={isRtl ? 'rtl' : 'ltr'}
      className={classnames('jimo-post-detail', {'is-rtl': isRtl})}
      style={{
        ...(backgroundColor != null ? {backgroundColor: backgroundColor} : {}),
        ...(boxShadow != null && {boxShadow}),
        ...(borderRadius != null
          ? {
              borderRadius: `${borderRadius}px`,
            }
          : {}),
      }}
    >
      <PostBlockThumbnail isDetail />
      <div className="jimo-post-detail-content">
        <PostDetailBlockTitle />
        <PostDetailBlockUser />
        <PostBlockLabel />
        <PostDetailBlockBody />
        <PostBlockCta />
        <PostBlockSocials />
      </div>
    </div>
  );
};
